import { render } from "./CampModalRecoverRegister.vue?vue&type=template&id=28d99ec4&ts=true"
import script from "./CampModalRecoverRegister.vue?vue&type=script&lang=ts"
export * from "./CampModalRecoverRegister.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/camp2/Devs/pontuei/pontuei-painel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__